export const ALLERGENS_DATA = [
  { id: "gluten", name: "Gluten", icon: "🌾" },
  { id: "crustaceans", name: "Crustaceos", icon: "🦐" },
  { id: "eggs", name: "Huevos", icon: "🥚" },
  { id: "fish", name: "Pescado", icon: "🐟" },
  { id: "peanuts", name: "Cacahuetes", icon: "🥜" },
  { id: "soy", name: "Soja", icon: "🫘" },
  { id: "milk", name: "Leche", icon: "🥛" },
  { id: "nuts", name: "Frutos de cascara", icon: "🌰" },
  { id: "celery", name: "Apio", icon: "🌿" },
  { id: "mustard", name: "Mostaza", icon: "🟡" },
  { id: "sesame", name: "Sesamo", icon: "⚪" },
  { id: "sulphites", name: "Sulfitos", icon: "🍷" },
  { id: "lupin", name: "Altramuces", icon: "🌸" },
  { id: "molluscs", name: "Moluscos", icon: "🐚" },
];
